/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { App } from 'store/App/types';
import { ICalculatorRules, IExportCalculatorSettings } from 'types';
import { TipCalculator } from '../TipCalculator/types';
import { CalculatorRules } from './types';

const initialState: ICalculatorRules | null = null;

export const calculatorRulesReducer: Reducer<ICalculatorRules | null> = (state = initialState, action) => {
  switch (action.type) {
    case CalculatorRules.GET_CALCULATOR_RULES_SUCCESS:
    case CalculatorRules.UPDATE_CALCULATOR_RULES_SUCCESS: {
      return action.payload;
    }
    case TipCalculator.IMPORT_CALCULATOR_SETTINGS_SUCCESS: {
      const { ruleSettings } = action.payload as IExportCalculatorSettings;
      return ruleSettings || state;
    }
    case App.SET_CURRENT_SITE: {
      if (action.payload?.siteId === state?.siteId) return state;
      return initialState;
    }
    default: {
      return state;
    }
  }
};
